import React from "react";
import styled from "styled-components";
import { Button } from "./Button";

const InputButton = styled(Button)<{ disableHover: boolean }>`
  height: 25px;
  width: 25px;
  margin: 0;
  padding: 0;
  font-size: 1.6rem;
  border: 1px solid black;
  &:hover {
    background: ${(props) => (props.disableHover ? "white" : "black")};
    color: ${(props) => (props.disableHover ? "black" : "white")};
  }
`;

const Number = styled.p`
  width: 25px;
  text-align: center;
  margin: 0;
  padding: 0;
  font-size: 1.6rem;
`;

const Wrapper = styled.span<{ disabled: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

export interface NumberInputProps {
  number: number;
  onIncrement: () => void;
  onDecrement: () => void;
  disabled?: boolean;
}

export const NumberInput: React.FC<NumberInputProps> = ({
  number,
  onIncrement,
  onDecrement,
  disabled,
}) => {
  disabled = disabled ? disabled : false;

  return (
    <Wrapper disabled={disabled ? disabled : false}>
      <InputButton
        onClick={!disabled ? onDecrement : undefined}
        disableHover={disabled ? disabled : false}
      >
        -
      </InputButton>
      <Number>{number}</Number>
      <InputButton
        onClick={!disabled ? onIncrement : undefined}
        disableHover={disabled ? disabled : false}
      >
        +
      </InputButton>
    </Wrapper>
  );
};
